import { render } from "./FormPurchaseOrderReceive.vue?vue&type=template&id=e6504d98"
import script from "./FormPurchaseOrderReceive.vue?vue&type=script&lang=js"
export * from "./FormPurchaseOrderReceive.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__